import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import IEventedComponent, {
  messageTypes
} from '../components/IEventedComponent'
import { SceneChangedEvent } from '../lib/messages'
import { MobileDeviceWidth } from '../lib/constants'

const Container = styled.div`
  border-left: 1px solid silver;
  padding-left: 20px;
  margin-top: -20px;
  padding-bottom: 14px;
  padding-top: 20px;
  position: relative;
  color: ${colours.black};
  @media (max-width: ${MobileDeviceWidth}px) {
    padding-left: 0;
    border-left: none;
  }
`

const dotSize = 12

const Dot = styled.div`
  width: ${dotSize}px;
  height: ${dotSize}px;
  border: 2px solid ${colours.mediumBlue};
  background: white;
  border-radius: 50%;
  position: absolute;
  left: -6px;
  top: 26px;
  @media (max-width: ${MobileDeviceWidth}px) {
    display: none;
  }
`

const ShownDot = styled(Dot)`
  background: ${colours.mediumBlue};
`

const ActiveDot = styled(ShownDot)`
  box-shadow: 0px 0px 8px 4px rgba(60, 90, 163, 0.7);
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      box-shadow: 0px 0px 8px 4px rgba(60, 90, 163, 0);
    }
    50% {
      box-shadow: 0px 0px 8px 4px rgba(60, 90, 163, 1);
    }
    100% {
      box-shadow: 0px 0px 8px 4px rgba(60, 90, 163, 0);
    }
  }
`

interface IProps {
  index: number
}

interface IState {
  shown: boolean
  active: boolean
}

class Scene extends IEventedComponent<IProps, IState> {
  state: IState = {
    shown: false,
    active: false
  }

  componentDidMount() {
    this.subscribe(messageTypes.onSceneChanged, this.handleActivate)
  }

  handleActivate = (message: SceneChangedEvent) => {
    if (message.sceneIndex === this.props.index) {
      this.setState({ active: true, shown: true })
      return
    }
    if (this.state.active) {
      this.setState({ active: false })
    }
  }

  renderDot = () => {
    if (this.state.active) return <ActiveDot className="dot active" />
    if (this.state.shown) return <ShownDot className="dot shown" />
    return <Dot className="dot" />
  }

  render() {
    return (
      <Container
        className="scene"
        data-scene-index={this.props.index}
        id={`scene-${this.props.index}`}
      >
        {this.renderDot()}
        <div
          style={{
            opacity: this.state.active ? 1 : 0.3,
            transition: 'opacity 0.6s'
          }}
        >
          {this.props.children}
        </div>
      </Container>
    )
  }
}

export default Scene
